import { Link, useRouter, usePathname } from '@/lib/next-shim-base';
import { getEnvVar } from '@/lib/env';

export const defaultNS = 'translation'
export const languages = ['fr', 'en', 'pt', 'es', 'it', 'ar'] as const
export type SupportedLanguage = typeof languages[number]

// Get the default language from environment variable, with 'fr' as fallback
const envDefaultLanguage = getEnvVar('NEXT_PUBLIC_DEFAULT_LANGUAGE', 'fr') as SupportedLanguage
export const fallbackLng: SupportedLanguage = languages.includes(envDefaultLanguage) ? envDefaultLanguage : 'fr'

export const langCookieName = 'i18next'

/**
 * Detect the best matching supported language from the browser's preferences.
 * Falls back to the configured fallbackLng if no match is found.
 */
export function detectBrowserLanguage(): SupportedLanguage {
  try {
    const browserLangs = navigator.languages ?? [navigator.language]
    for (const browserLang of browserLangs) {
      // Exact match (e.g. "fr")
      const exact = browserLang.toLowerCase() as SupportedLanguage
      if ((languages as readonly string[]).includes(exact)) return exact

      // Base language match (e.g. "fr-FR" → "fr", "pt-BR" → "pt")
      const base = browserLang.split('-')[0].toLowerCase() as SupportedLanguage
      if ((languages as readonly string[]).includes(base)) return base
    }
  } catch {
    // SSR or navigator unavailable
  }
  return fallbackLng
}

export { useRouter, usePathname, Link };
